const experiments = {};
export const registerExperiment = (name, supportedVariants, experimentType = 'user') => {
    experiments[name] = { name, supportedVariants, experimentType };
};
export const getRegisteredExperiments = () => Object.values(experiments);
//# sourceMappingURL=register-experiment.js.map